import classNames from 'classnames'
import { motion } from 'framer-motion'
import React, { PropsWithChildren } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { Column } from '../Column'
import classes from './detailVerticalTab.module.scss'
import { TabsProps } from './types'

const DesktopDetailVerticalTab: React.FC<PropsWithChildren<TabsProps>> = ({ data, strokeColor }) => {
  const tabClasses = [classes.colorColumn]

  switch (strokeColor) {
  case 'blue':
    tabClasses.push(classes.lineBlue)
    break
  case 'yellow':
    tabClasses.push(classes.lineYellow)
    break
  case 'orange':
    tabClasses.push(classes.lineOrange)
    break
  case 'purple':
    tabClasses.push(classes.linePurple)
    break
  case 'green':
    tabClasses.push(classes.lineGreen)
    break
  case 'red':
    tabClasses.push(classes.lineRed)
    break
  default:
    break
  }

  return (
    <>
      <Tabs defaultIndex={0} className={classes.tabsContainer}>
        <TabList className={classes.tabList}>
          <motion.li initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ delay: 0 }}>
            <h2 className={classes.componentTitle}>{data.title}</h2>
          </motion.li>
          {data?.tabList?.length > 0 && data.tabList.map((item, idx) => (
            <Tab key={idx}>
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ delay: 0.25 * idx }}>
                <p className={classes.tabContainer}>
                  {item}
                </p>
              </motion.div>
            </Tab>
          ))}
        </TabList>
        <div className={classNames(tabClasses)} />
        <div className={classes.tabPanelContainer}>
          {data?.tabContent && data?.tabContent?.length > 0 && data?.tabContent?.map((item) => {
            return (
              <TabPanel key={item.id} className={classes.tabPanel}>
                <div className={classes.columnsContent}>
                  <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ delay: 0.5 }}>
                    <h2>{item.title}</h2>
                  </motion.div>
                  <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ delay: 0.7 }}>
                    <p className={classes.subtitle}>{item.subtitle}</p>
                  </motion.div>
                  <div className={classes.columnsContainer}>
                    {item?.content && item?.content?.length > 0 && item?.content?.map((content, idx) => (
                      <motion.div className={classes.columnMotion} key={`${item.id}-${idx}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ delay: 1 + (0.2 * idx) }} >
                        <Column className={classes.column} body={{ content: content?.body?.content }} key={idx} href={''} variant={'default'} src={{
                          filename: '',
                          alt: '',
                        }} component={'column'} _uid={''} size={'default'} align={'center'} full_width={true} mob_size={'default'} />
                      </motion.div>
                    ))}
                  </div>
                  <div className={classes.columnsContainer}>
                    {item?.lowerContent && item?.lowerContent?.length > 0 && item?.lowerContent?.map((content, idx) => (
                      <motion.div className={classes.columnMotion} key={`${item.id}-${idx}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ delay: 1 + (0.2 * idx) }} >
                        <Column className={classes.column} body={{ content: content?.body?.content }} key={idx} href={''} variant={'default'} src={{
                          filename: '',
                          alt: '',
                        }} component={'column'} _uid={''} size={'default'} align={'center'} full_width={true} mob_size={'default'} />
                      </motion.div>
                    ))}
                  </div>
                </div>
              </TabPanel>
            )
          })}
        </div>
      </Tabs>
    </>
  )
}

export default DesktopDetailVerticalTab